import type {CallIdentity} from '../model/types';

const PALETTE = ['violet', 'blue', 'green', 'red', 'yellow', 'purple', 'mint', 'amber', 'orange'] as const;

const hashOf = (value: string): number => [...value].reduce((hash, char) => (hash * 31 + char.charCodeAt(0)) >>> 0, 7);

export const avatarTone = (identity: CallIdentity): string => {
    const seed = identity.userId ?? identity.name;
    return seed ? `phq-call-avatar-${PALETTE[hashOf(String(seed)) % PALETTE.length]}` : 'phq-call-avatar-unknown';
};
